import BigNumber from 'bignumber.js'
import React, { useEffect, useRef } from 'react'
import CountUp from 'react-countup'
import { getFullDisplayBalance } from 'utils/formatBalance'
import Text, { TextProps } from 'UIKit/Text'

interface BalanceProps extends TextProps {
  value: number
  decimals?: number
  unit?: string
  isDisabled?: boolean
  prefix?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const Balance: React.FC<BalanceProps> = ({
  value,
  color = 'text',
  decimals = 6,
  isDisabled = false,
  unit,
  prefix,
  onClick,
  ...props
}) => {
  const previousValue = useRef(0)

  useEffect(() => {
    previousValue.current = !value || Number.isNaN(value) ? 0 : value
  }, [value])

  return (
    <Text color={isDisabled ? 'textDisabled' : color} onClick={onClick} {...props}>
      <CountUp
        formattingFn={(value) => {
          return getFullDisplayBalance(new BigNumber(Math.floor(value * 10 ** decimals) / 10 ** decimals), 0, decimals)
        }}
        start={previousValue.current}
        end={value}
        prefix={prefix}
        suffix={unit}
        decimals={decimals + 1}
        duration={1}
        separator=","
      />
    </Text>
  )
}

export default Balance
